import React from "react";
import { useTranslation } from 'react-i18next';
import "../styles/RentTutorialStriemoKey.css";
import { useNavigate } from 'react-router-dom';

const RentTutorialStriemoKey = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <main>
          <section className="app__guide-jp" id="appguide-jp">
            <div className="inner-app">
              <h2 className="section-ttl">{t('How to use Striemo')}</h2>
              <ul className="rental-warapper">
                {/* 1 */}
                <li className="rental-list">
                  <div className="use__img-area">
                    <figure className="use__img">
                      <img src="/images/striemo_key/striemo-key.png" alt="ダイヤルロック" />
                    </figure>
                  </div>
                  <div className="rental__ttl-area">
                    <h3 className="rental__ttl">
                      1.Striemoの後輪についている赤いダイヤルロックを解除してください。
                    </h3>
                  </div>
                  <p className="rental-discription">
                    ※解除番号はご利用案内のメールに記載がございます。
                    ※ダイヤルロックは返却時までご自身で管理をお願いいたします。
                  </p>
                </li>

                {/* 2 */}
                <li className="rental-list">
                  <div className="use__img-area">
                    <figure className="use__img">
                      <img src="/images/striemo_key/btn.png" alt="電源ボタン" />
                    </figure>
                  </div>
                  <div className="rental__ttl-area">
                    <h3 className="rental__ttl">2.Striemoの電源を入れてください。</h3>
                  </div>
                  <p className="rental-discription">
                    黒い丸の円の右下にある電源ボタンを長押ししてください。
                  </p>
                </li>

                {/* 3 */}
                <li className="rental-list">
                  <div className="use__img-area">
                    <figure className="use__img">
                      <img src="/images/striemo_key/speed.png" alt="スピード設定" />
                    </figure>
                  </div>
                  <div className="rental__ttl-area">
                    <h3 className="rental__ttl">3.電源が入ったら、スピードを設定してください。</h3>
                  </div>
                  <p className="rental-discription">
                    黒い円の下側にある上下のボタンで速度の調整ができます。
                    2は速度が約5.5km/h、1は約4km/h、Pは約2.5km/hの速度で走行することができます。
                  </p>
                </li>

                {/* 4 */}
                <li className="rental-list">
                  <div className="use__img-area">
                    <figure className="use__img">
                      <img src="/images/striemo_key/accelerator.png" alt="アクセルレバー" />
                    </figure>
                  </div>
                  <div className="rental__ttl-area">
                    <h3 className="rental__ttl">
                      4.右ハンドルにあるレバーを親指で前に押すと進み、離すと減速します。
                    </h3>
                  </div>
                  <p className="rental-discription">レバーはどちらか片方でOK！</p>
                </li>

                {/* 5 */}
                <li className="rental-list">
                  <div className="use__img-area">
                    <figure className="use__img">
                      <img src="/images/striemo_key/brake.png" alt="ブレーキレバー" />
                    </figure>
                  </div>
                  <div className="rental__ttl-area">
                    <h3 className="rental__ttl">
                      5.完全に停止したいときは、ブレーキレバーを引いてください。
                    </h3>
                  </div>
                  <p className="rental-discription">
                    必要に応じて左右のブレーキレバーで減速・停止をしてください。
                  </p>
                </li>

                {/* 6 */}
                <li className="rental-list">
                  <div className="use__img-area">
                    <figure className="use__img">
                      <img src="/images/striemo_key/parking.png" alt="パーキングレバー" />
                    </figure>
                  </div>
                  <div className="rental__ttl-area">
                    <h3 className="rental__ttl">
                      6.途中駐車したい場合はパーキングブレーキを行ってください。
                    </h3>
                  </div>
                  <p className="rental-discription">
                    駐車する場合は、左のブレーキレバーを強く握り、ロックレバーを人差し指で引き、固定してください。
                  </p>
                </li>

                {/* 7 */}
                <li className="rental-list">
                  <div className="use__img-area">
                    <figure className="use__img">
                      <img src="/images/striemo_key/backbtn.png" alt="バックボタン" />
                    </figure>
                  </div>
                  <div className="rental__ttl-area">
                    <h3 className="rental__ttl">Rのボダンを長押し続けると後退します。</h3>
                  </div>
                </li>
              </ul>

              <div className="rental__message-area">
                <p className="rental-message">
                  これで利用方法の説明は終了です！<br />
                  体験をお楽しみください。
                </p>
              </div>

              <div className="cp_arrows">
                <div className="cp_arrow"></div>
                <div className="cp_arrow"></div>
              </div>
            </div>
          </section>
          <button type="button" className="mode-button" onClick={() => {
              navigate('/guide');
            }}>
        <span className="text-wrapper-6">次へ進む</span>
      </button>
        </main>
    );
};

export default RentTutorialStriemoKey;
